<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row" v-if="userData.permissions['books_borrowed']==1"> 
  
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-bookborrowed size="sm" variant="primary"><i class="mdi mdi-plus"></i> Lend a Book</b-button>
              </div><div class="my-2">
                <div class="row">
                  <!-- <b-form-group class="col-md-3" label="Term">
                    <v-select :options="schoolterms" placeholder="Select Term" v-model="schoolterm" label="name"></v-select>
                  </b-form-group> -->
                  <b-form-group class="col-md-3" label="Year">
                    <v-select :options="years" placeholder="Select Year" v-model="year"></v-select>
                  </b-form-group>
                  <div class="col-md-2 mt-md-4 mt-2 p-lg-0">
                  <b-button variant="primary" @click="FilterData()"><i class="mdi mdi-account-search"></i> Filter</b-button>
                  </div>
                </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(borrowerr)="data">
                  <!-- <span v-if="data.item.type=='Student'"> -->
                    <b >{{ data.item.borrower.first_name }} {{ data.item.borrower.last_name }} </b> <br> <small class="text-primary">{{ data.item.borrower.student_id}}</small>
                  <!-- </span>
                  <span v-else>
                    <b class="text-primary">{{ data.item.borrower.username }}</b> <br>
                  </span> -->
                </template> 
                <template #cell(booktitle)="data">
                  <b class="text-danger">{{ data.item.booktitle.booktitle }}</b> <br><small>{{ data.item.booktitle.author }}</small>
                </template> 
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <span v-if="data.item.quantitytaken !== data.item.quantityreturned">
                      <b-button @click="edit(data.item.id,data.item.returndate,data.item.quantityreturned,data.item.quantitylost)" type="button" class="btn-sm btn" variant="info" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i>Return</b-button>
                      </span>
                    <span v-else>
                      <b-button type="button" class="btn-sm btn" variant="success"><i class="mdi mdi-check" style="font-size: 9 px;">Returned</i></b-button>
                    </span>
                  <!-- <b-button @click="edit(data.item.id,data.item.returndate,data.item.quantityreturned,data.item.quantitylost)" type="button" class="btn-sm btn" variant="info" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i>return</b-button> -->
                  <b-button @click="remove(data.item.id)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can" ></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
            <div class="row d-flex justify-content-center">
              <div class="col" >
                Total Books Borrowed :<b> {{ totalborrowed}}</b>
              </div>
              <div class="col">
            Total Books Returned :<b> {{totalreturned }}</b>
              </div>
              <div class="col">
               Total Books Lost :<b> {{ totallost }}</b>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <b-modal id="new-bookborrowed" centered title="Lend a Book" title-class="font-18" hide-footer>
          <form @submit.prevent="addBookBorrowed">
              <div class="form-group mb-2">
                <input v-model="id" type="hidden">
                <!-- <label>Borrower type</label>
                <select class="form-control" v-model="type"><option>Staff</option><option>Student</option></select> -->
                <label>Borrower : <small class="text-primary">{{borrower.student_id}}</small></label>
                 <multiselect v-model="borrower" :options="students" placeholder="Select Borrower"
                :custom-label="customLabel"
                > </multiselect> 
                
              <!-- <multiselect v-if="type == 'Student'" v-model="borrower" :options="students" placeholder="Select Borrower"
                 :custom-label="customLabel"
                 :reduce="students => students.student.student_id"
                 > </multiselect> 
               <v-select  v-else-if="type == 'Staff'"  :options="users" placeholder="Select Borrower" v-model="borrower" :reduce="users => users.id">
                <template slot="option" slot-scope="option">
                  <div>{{ option.full_name }} </div> 
                </template> 
                <template slot="selected-option" slot-scope="option">
                  <div>{{ option.full_name }}</div> 
                </template>
            </v-select>  -->
                <label>Book Title</label>
                <multiselect v-model="booktitle" label="booktitle" :options="librarybooks"></multiselect>
                <label>Quantity taken</label>
                <small class="text-primary"> Available:  <b> {{ booktitle.quantity }} </b></small>
                <b-form-input v-if="type === 'Student' ? quantitytaken = 1 : true" v-model="quantitytaken" type="number" :max="booktitle.quantity"></b-form-input>
                <b-form-input v-else v-model="quantitytaken"  type="number" :max="booktitle.quantity"></b-form-input>

                <label>Date taken</label>
                <b-form-input v-model="datetaken" label="date taken" type="date" :min="current"></b-form-input>   
                <label>Return date</label>
                <b-form-input v-model="returndate" label="returning date" type="date" :min="datetaken"></b-form-input>
                </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-bookborrowed')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="edit-bookborrowed" centered title="Return a book " title-class="font-14" hide-footer>         

          <form @submit.prevent="editBookBorrowed">
              <div class="form-group mb-2">
                <input v-model="id" type="hidden"> 
                  <label>Return date</label>
                  <b-form-input v-model="returndate" label="return date" type="date" :min="current" ></b-form-input>
                  <label>Quantity returned</label>
                  <b-form-input v-model="quantityreturned" type="number"></b-form-input> 
                  <label>Quantity lost</label>
                  <b-form-input v-model="quantitylost" type="number"></b-form-input> 
                </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-bookborrowed')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-bookborrowed" centered title="Delete Record" title-class="font-18" hide-footer>
          <form @submit.prevent="removeBookBorrowed">
              <input v-model="id" type="hidden">
                Are you sure you want to delete the Record ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-bookborrowed')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal>
    </div>  
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
          </div>
        </div>
      </div>
    </div>    
  
    </Layout>
  </template>
  
  <script>
  import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { booksBorrowedComputed, booksBorrowedMethods, libraryBooksComputed, libraryBooksMethods, schooltermComputed, schooltermMethods, studentComputed, studentMethods, userComputed, userMethods } from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
  
  export default {
    page: {
      title: "Books Borrowed",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader,Multiselect
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Books Borrowed",
        items: [ {text: "Dashboard",to: "/",}, {text: "Books Borrowed",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'booktitle', label: 'Book title', visible: true },
            { key: 'borrowerr',label:'Borrower', visible:true},
            // { key: 'type', label:'Type', visible:true},
            { key: 'quantitytaken',label:'Quantity taken', visible:true},
            { key: 'quantityreturned',label:'Quantity returned', visible:true},             
            { key: 'quantitylost',label:'Quantity lost', visible:true}, 
            { key: 'datetaken',label:'Date taken', visible: true},
            { key: 'returndate',label:'Return date', visible: true},
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'', student_id:'',booktitle:'',borrower:'',returndate:'',quantitytaken:'',type:'',schoolterm:'',year:new Date().getFullYear(),
        student:'',quantityreturned:'',quantitylost:'',datetaken:'',
      current:new Date().toLocaleDateString('fr-CA'),
        
      };
    },
    computed: {
      ...studentComputed,
      ...userComputed,
      ...schooltermComputed,
      ...booksBorrowedComputed,
      ...libraryBooksComputed,
     
      List() { return this.booksborrowed.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.booksborrowed.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.booksborrowed.length>0) { a=false;} else { a=true;} return a },
      years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {  yearArray.push(year);  }
      return yearArray;
    },

    totalborrowed(){ var total = 0; this.booksborrowed.forEach((item)=>{ var item_total = item.quantitytaken; total = Number(total)+Number(item_total);}); return total },
    totalreturned(){ var total = 0; this.booksborrowed.forEach((item)=>{ var item_total = item.quantityreturned; total = Number(total)+Number(item_total);}); return total },
    totallost(){ var total = 0; this.booksborrowed.forEach((item)=>{ var item_total = item.quantitylost; total = Number(total)+Number(item_total);}); return total },
    },
    mounted() {
      this.fetchStudents();
      this.fetchUsers();
      this.fetchSchoolTerms(); 
      this.fetchBooksBorrowed();
      this.fetchLibraryBooks();
      this.TotalRows = this.booksborrowed.length;
      this.isBusy=false;
      this.schoolterm = this.schoolterms.find(option => option.active == 1);
    },
    methods: {
      ...studentMethods, 
      ...userMethods,
      ...schooltermMethods, 
      ...booksBorrowedMethods,
      ...booksBorrowedMethods,
      ...libraryBooksMethods,
      customLabel(student) {
   return `${student.student.first_name} ${student.student.last_name} ${student.class.name } ${student.stream.name } `;
},
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,returndate ,quantityreturned,quantitylost){
        this.id=id;
        this.returndate = returndate;
        this.quantityreturned=quantityreturned;
        this.quantitylost=quantitylost;
        this.$bvModal.show('edit-bookborrowed')
      },
      remove(id){
        this.id=id;
        this.$bvModal.show('delete-bookborrowed')
      },
      checkStatus(){
        if(this.borrower.status ==1){
          this.$bvToast.toast("Already took a book.")
        }
      },
      async addBookBorrowed() { 
        let formData = new FormData();
        formData.append("booktitle", this.booktitle.id);
        //  formData.append("borrower",this.borrower);
        formData.append("borrower", this.borrower.student.student_id);

        formData.append("quantitytaken",this.quantitytaken);
        formData.append("type", this.type);
        formData.append("datetaken",this.datetaken);
        formData.append("returndate",this.returndate);
        let url = "/borrowbooks";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchStudents();
            this.fetchBooksBorrowed();
            this.fetchUsers()
            this.$bvModal.hide('new-bookborrowed');
            this.booktitle="";
            this.borrower="";
            this.quantitytaken="";
            this.type="";
            this.datetaken="";
            this.returndate="";
            this.$swal({ title:'Successfully added', text:response.data.message, icon:'success'});
        }
        });
      },
      async editBookBorrowed(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("returndate", this.returndate);
      formData.append("quantityreturned",this.quantityreturned);
      formData.append("quantitylost",this.quantitylost);
      let url = "/editbook";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
        this.fetchBooksBorrowed();
        this.$bvModal.hide('edit-bookborrowed');
        this.id="";
        this.$swal({ title:'Success', text:response.data.message, icon:'success'});
        }
      });
      },
      async removeBookBorrowed() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removebooksborrowed";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchBooksBorrowed();
          this.$bvModal.hide('delete-bookborrowed');
          this.$swal({ title:'Success', text:response.data.message, icon:'success'});
        }
      });
      },
    },
    FilterData() {
      this.filterBooksBorrowed({schoolterm:this.schoolterm.id,year:this.year});
    },
  };
  </script>